module.exports = __webpack_public_path__ + "static/media/chair2right.e0d68ddb.png";